import { useParams, useNavigate, useLocation } from 'react-router-dom'

import CloseRequestModal from '@/buyers/components/CloseRequestModal'

const CloseRequest = () => {
  const { rfqId } = useParams() as { rfqId: string }
  const navigate = useNavigate()
  const location = useLocation()
  const close = () => navigate(`/rfqs/${rfqId}`)

  const hasUnfulfilledQuantities = (location.state as { hasUnfulfilledQuantities?: boolean })
    ?.hasUnfulfilledQuantities

  return (
    <CloseRequestModal
      rfqId={rfqId}
      close={close}
      onOk={close}
      hasUnfulfilledQuantities={hasUnfulfilledQuantities}
    />
  )
}

export default CloseRequest
